<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_topevent') : $t('labels.add_topevent') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="topevent_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.topevent_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('topevent_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 mt-4">
              <label>{{ $t('labels.hazards')}}</label>
              <v-select
                multiple
                name="hazard"
                class="mt-1"
                v-model="hazard"
                :options="parentHazard"
                :reduce="parentHazard => parentHazard.id"
                label="name"
                :closeOnSelect="false"
              />
            </div>
          </div>
          <div class="mt-6 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-topevent"
              button="submit"
            >{{ editRoute ? $t('labels.update_topevent') : $t('labels.add_topevent') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      name: "",
      hazard: [],
      parentHazard: []
    };
  },
  components: {
    "v-select": vSelect
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getHazards();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getTopevents();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateTopevents();
        }
      });
    },
    // API Integration for add-update top-events
    async createUpdateTopevents() {
      let input = {
        name: this.name,
        hazard_ids: this.hazard
      };
      let url = this.editRoute
        ? "/top-events/update/" + this.editRoute
        : "/top-events/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-topevent",
        true
      );
      if (response) {
        this.$router.push({ name: "Topevents" });
      }
    },
    async getTopevents() {
      let response = await this.getHTTPGetResponse(
        "/top-events/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let topevent = data.top_event;
        this.name = topevent.name;
        let filteredHazards = [];
        for (var i = 0; i < topevent.hazards.length; i++) {
          filteredHazards.push(topevent.hazards[i].id);
        }
        this.hazard = filteredHazards;
      }
    },
    async getHazards() {
      let input = {
        name: this.hazard
      };
      let response = await this.getHTTPPostResponse("/hazards/list", input);
      if (response) {
        let hazard_req = response.data.hazards;
        let filteredHazards = [];
        for (var i = 0; i < hazard_req.length; i++) {
          let obj = { id: hazard_req[i].id, name: hazard_req[i].name };
          filteredHazards.push(obj);
        }
        this.parentHazard = filteredHazards;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>